import React, { useEffect, useRef } from 'react';
import ReactDOMServer from 'react-dom/server';

import useEmailStyles from './styles';

function Section({
  nodeData,
  emailRef,
  customHtmlData,
  renderHTML = false,
  isProceed = false,
  pixel,
  landingLink
}) {
  const header = nodeData?.components[0];
  const body = nodeData?.components[1];
  const landing = nodeData?.components[2];
  const footer = nodeData?.components[3];

  const classes = useEmailStyles();
  return (
    <>
      <center className={classes.wrapper} ref={emailRef}>
        {isProceed && pixel}
        <table
          className={classes.main}
          style={{
            width: '100%',
            maxWidth: '600px',
            backgroundColor: '#ffffff'
          }}
        >
          <tbody>
            {customHtmlData?.isCustomHtml ? (
              <div
                className={classes.email_description_para}
                dangerouslySetInnerHTML={{
                  __html: `${customHtmlData?.html ? customHtmlData?.html : ''}`
                  // __html: '<div>sdnfksdnflksdnfklsndk</div>'
                }}
              ></div>
            ) : (
              <>
                {header?.isActive ? (
                  <>
                    <tr>
                      <td>
                        <table
                          style={{
                            textAlign: 'center',
                            background: '#ffffff',
                            paddingTop: '16px',
                            width: '100%'
                          }}
                        >
                          <tr>
                            <td style={{ display: 'inline-block' }}>
                              {header?.components[0]?.metadata?.image
                                ?.length ? (
                                <img
                                  src={header?.components[0]?.metadata?.image}
                                  alt=""
                                  style={{ width: 'auto', height: '48px' }}
                                />
                              ) : renderHTML ? null : (
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontStyle: 'italic',
                                    minHeight: '30px'
                                  }}
                                >
                                  Your logo
                                </div>
                              )}
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: 'center' }}>
                        {header?.components[1]?.metadata?.image?.length ? (
                          <img
                            src={header?.components[1]?.metadata?.image}
                            // width={600}
                            alt=""
                            style={{
                              maxWidth: '600px',
                              width: '100%',
                              marginBottom: '-4px'
                            }}
                          />
                        ) : renderHTML ? null : (
                          <div
                            style={{
                              maxWidth: '600px',
                              width: '100%',
                              marginBottom: '-4px',
                              minHeight: '250px',
                              background: '#F4F9FD',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontStyle: 'italic'
                            }}
                          >
                            Cover Image
                          </div>
                        )}
                      </td>
                    </tr>
                  </>
                ) : null}
                {/*
      <!-- ----------------------------Welcome Community------------------- --> */}
                {body && body?.isActive ? (
                  <tr>
                    <td>
                      <table
                        style={{
                          textAlign: 'center',
                          width: '100%',
                          backgroundColor: '#ffffff',
                          padding: '0px 24px'
                        }}
                      >
                        <tr>
                          <td>
                            <p
                              style={{
                                // fontFamily: 'Roboto',
                                fontStyle: 'normal',
                                fontWeight: '700',
                                fontSize: '24.2487px',
                                lineHeight: '29px',
                                textAlign: 'center',
                                color: '#00ade7',
                                marginTop: '24px'
                              }}
                              ref={body?.components[0]?.refSetter}
                            >
                              {body?.components[0]?.metadata?.text}
                            </p>
                            <p
                              style={{
                                // fontFamily: 'Roboto',
                                fontStyle: 'normal',
                                fontWeight: '500',
                                fontSize: '18.1865px',
                                lineHeight: '22px',
                                textAlign: 'center',
                                color: '#0a1629',
                                marginTop: '8px',
                                marginBottom: '15px'
                              }}
                              ref={body?.components[1]?.refSetter}
                            >
                              {body?.components[1]?.metadata?.text}
                            </p>
                            <div
                              style={{
                                // maxWidth: '435px',
                                // margin: '0px 10px',
                                // fontFamily: 'Roboto',
                                fontStyle: 'normal',
                                fontWeight: '400',
                                fontSize: '16.1658px',
                                lineHeight: '22px',
                                color: '#3c4852',
                                textAlign: 'left'
                              }}
                              dangerouslySetInnerHTML={{
                                __html: body?.components[2]?.metadata?.text
                              }}
                              className={classes.email_description_para}
                              ref={body?.components[2]?.refSetter}
                            >
                              {/* {body?.components[2]?.metadata?.text} */}
                            </div>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                ) : null}

                {landing?.isActive ? (
                  <tr>
                    <td>
                      <table
                        style={{
                          width: '100%',
                          padding: '12px'
                        }}
                      >
                        <tr>
                          <td>
                            <table
                              style={{
                                width: '100%',
                                background: '#f4f9fd',
                                borderRadius: '16px',
                                padding: '32px',
                                textAlign: 'center'
                              }}
                            >
                              <tr>
                                <td style={{ textAlign: 'center' }}>
                                  {landing?.components[0]?.metadata?.image
                                    ?.length ? (
                                    <img
                                      src={
                                        landing?.components[0]?.metadata?.image
                                      }
                                      alt=""
                                      style={{
                                        maxWidth: '600px',
                                        width: '100%',
                                        borderRadius: '10px'
                                      }}
                                    />
                                  ) : renderHTML ? null : (
                                    <div
                                      style={{
                                        background: '#D9D9D9F0',
                                        width: '100%',
                                        minHeight: '250px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontStyle: 'italic',
                                        borderRadius: '10px'
                                      }}
                                    >
                                      Thumbnail Image
                                    </div>
                                  )}

                                  <p
                                    style={{
                                      // fontFamily: 'Roboto',
                                      fontStyle: 'normal',
                                      fontWeight: '500',
                                      fontSize: '18.1865px',
                                      lineHeight: '22px',
                                      color: '#0a1629',
                                      marginTop: '16px',
                                      marginBottom: '16px',
                                      textAlign: 'left'
                                    }}
                                    ref={landing?.components[1]?.refSetter}
                                  >
                                    {landing?.components[1]?.metadata?.text}
                                  </p>
                                  {/* <a
                                    href={isEdit ? "/" :
                                      landing?.components[3]?.metadata?.text
                                    }
                                    // target="_blank"
                                    style={{ textDecoration: 'none' }}
                                  > */}
                                  <a
                                    href={landingLink}
                                    target="_blank"
                                    style={{ textDecoration: 'none' }}
                                  >
                                    <p
                                      style={{
                                        background: '#009AE0',
                                        borderRadius: '7.18333px',
                                        color: 'white',
                                        textDecoration: 'none',
                                        padding: '12px 0px',
                                        // fontFamily: 'Roboto',
                                        cursor: 'pointer',
                                        fontStyle: 'normal',
                                        fontWeight: '600 ',
                                        fontSize: '20.55px',
                                        lineHeight: '32px',
                                        textTransform: 'uppercase',
                                        color: '#fafafa'
                                      }}
                                      ref={landing?.components[2]?.refSetter}
                                    >
                                      {landing?.components[2]?.metadata?.text}
                                    </p>
                                  </a>
                                  {/* </a> */}
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                ) : null}

                {footer?.isActive ? (
                  <tr>
                    <td>
                      <table
                        style={{
                          width: '100%',
                          background: '#e3f0ff',
                          textAlign: 'center'
                        }}
                      >
                        <tr>
                          <td>
                            <p
                              style={{
                                // fontFamily: 'Roboto',
                                fontStyle: 'normal',
                                fontWeight: '700',
                                fontSize: '18px',
                                lineHeight: '29px',
                                textAlign: 'center',
                                color: '#0a1629',
                                marginTop: '32px'
                              }}
                            >
                              Connect with us on:
                            </p>

                            <table
                              style={{
                                width: '100%',
                                marginTop: '8px',
                                marginBottom: '16px'
                              }}
                            >
                              <tbody>
                                <tr>
                                  <td>
                                    <div>
                                      <a
                                        href={
                                          footer?.components[0]?.metadata?.text
                                            ? footer?.components[0]?.metadata
                                                ?.text
                                            : undefined
                                        }
                                        target="_blank"
                                        style={{
                                          textDecoration: 'none',
                                          display:
                                            renderHTML &&
                                            footer?.components[0]?.metadata
                                              ?.text
                                              ? ''
                                              : renderHTML === false
                                              ? ''
                                              : 'none'
                                        }}
                                      >
                                        <img
                                          src={
                                            footer?.components[0]?.metadata
                                              ?.text
                                              ? footer?.components[0]?.metadata
                                                  ?.iconUrlColor
                                              : footer?.components[0]?.metadata
                                                  ?.iconUrl
                                          }
                                          alt=""
                                          style={{
                                            width: '36px',
                                            height: '36px',
                                            margin: '0px 12px',
                                            cursor: 'pointer'
                                          }}
                                          ref={footer?.components[0]?.refSetter}
                                        />
                                      </a>
                                      <a
                                        href={
                                          footer?.components[1]?.metadata?.text
                                            ? footer?.components[1]?.metadata
                                                ?.text
                                            : undefined
                                        }
                                        target="_blank"
                                        style={{
                                          textDecoration: 'none',
                                          display:
                                            renderHTML &&
                                            footer?.components[1]?.metadata
                                              ?.text
                                              ? ''
                                              : renderHTML === false
                                              ? ''
                                              : 'none'
                                        }}
                                      >
                                        <img
                                          src={
                                            footer?.components[1]?.metadata
                                              ?.text
                                              ? footer?.components[1]?.metadata
                                                  ?.iconUrlColor
                                              : footer?.components[1]?.metadata
                                                  ?.iconUrl
                                          }
                                          alt=""
                                          style={{
                                            width: '36px',
                                            height: '36px',
                                            margin: '0px 12px',
                                            cursor: 'pointer'
                                          }}
                                          ref={footer?.components[1]?.refSetter}
                                        />
                                      </a>
                                      <a
                                        href={
                                          footer?.components[2]?.metadata?.text
                                            ? footer?.components[2]?.metadata
                                                ?.text
                                            : undefined
                                        }
                                        target="_blank"
                                        style={{
                                          textDecoration: 'none',
                                          display:
                                            renderHTML &&
                                            footer?.components[2]?.metadata
                                              ?.text
                                              ? ''
                                              : renderHTML === false
                                              ? ''
                                              : 'none'
                                        }}
                                      >
                                        <img
                                          src={
                                            footer?.components[2]?.metadata
                                              ?.text
                                              ? footer?.components[2]?.metadata
                                                  ?.iconUrlColor
                                              : footer?.components[2]?.metadata
                                                  ?.iconUrl
                                          }
                                          alt=""
                                          style={{
                                            width: '36px',
                                            height: '36px',
                                            cursor: 'pointer',
                                            margin: '0px 12px'
                                          }}
                                          ref={footer?.components[2]?.refSetter}
                                        />
                                      </a>
                                      <a
                                        href={
                                          footer?.components[3]?.metadata?.text
                                            ? footer?.components[3]?.metadata
                                                ?.text
                                            : undefined
                                        }
                                        target="_blank"
                                        style={{
                                          textDecoration: 'none',
                                          display:
                                            renderHTML &&
                                            footer?.components[3]?.metadata
                                              ?.text
                                              ? ''
                                              : renderHTML === false
                                              ? ''
                                              : 'none'
                                        }}
                                      >
                                        <img
                                          src={
                                            footer?.components[3]?.metadata
                                              ?.text
                                              ? footer?.components[3]?.metadata
                                                  ?.iconUrlColor
                                              : footer?.components[3]?.metadata
                                                  ?.iconUrl
                                          }
                                          alt=""
                                          style={{
                                            width: '36px',
                                            height: '36px',
                                            margin: '0px 12px',
                                            cursor: 'pointer'
                                          }}
                                          ref={footer?.components[3]?.refSetter}
                                        />
                                      </a>
                                      <a
                                        href={
                                          footer?.components[4]?.metadata?.text
                                            ? footer?.components[4]?.metadata
                                                ?.text
                                            : undefined
                                        }
                                        target="_blank"
                                        style={{
                                          textDecoration: 'none',
                                          display:
                                            renderHTML &&
                                            footer?.components[4]?.metadata
                                              ?.text
                                              ? ''
                                              : renderHTML === false
                                              ? ''
                                              : 'none'
                                        }}
                                      >
                                        <img
                                          src={
                                            footer?.components[4]?.metadata
                                              ?.text
                                              ? footer?.components[4]?.metadata
                                                  ?.iconUrlColor
                                              : footer?.components[4]?.metadata
                                                  ?.iconUrl
                                          }
                                          alt=""
                                          style={{
                                            width: '36px',
                                            height: '36px',
                                            cursor: 'pointer',
                                            margin: '0px 12px'
                                          }}
                                          ref={footer?.components[4]?.refSetter}
                                        />
                                      </a>
                                      <table
                                        style={{
                                          width: '100%',
                                          marginTop: '13px'
                                        }}
                                      >
                                        <tr>
                                          <td>
                                            <p
                                              style={{
                                                // fontFamily: 'Roboto',
                                                fontStyle: 'normal',
                                                fontWeight: '400',
                                                fontSize: '14.1451px',
                                                lineHeight: '21px',
                                                textAlign: 'center',
                                                color: '#7d8592'
                                              }}
                                            >
                                              For any concerns, mail us at&nbsp;
                                              {footer?.components[5]?.metadata
                                                ?.text
                                                ? footer?.components[5]
                                                    ?.metadata?.text
                                                : ''}
                                            </p>
                                            <p
                                              style={{
                                                // fontFamily: 'Roboto',
                                                fontStyle: 'normal',
                                                fontWeight: '400',
                                                fontSize: '14.1451px',
                                                lineHeight: '24px',
                                                textAlign: 'center',
                                                color: '#7d8592'
                                              }}
                                            >
                                              Copyright © 2024 |&nbsp;
                                              {footer?.components[0]?.metadata
                                                ?.text
                                                ? footer?.components[0]
                                                    ?.metadata?.text
                                                : ''}
                                            </p>
                                            <p
                                              style={{
                                                // fontFamily: 'Roboto',
                                                fontStyle: 'normal',
                                                fontWeight: '400',
                                                fontSize: '14.1451px',
                                                lineHeight: '24px',
                                                textAlign: 'center',
                                                color: '#7d8592',
                                                marginBottom: '22px'
                                              }}
                                            >
                                              All rights reserved.
                                            </p>
                                          </td>
                                        </tr>
                                      </table>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                ) : null}
              </>
            )}
          </tbody>
        </table>
      </center>
    </>
  );
}

export default function EmailDripMarket({ sectionData, extraProps = {} }) {
  const isInitialMount = useRef(true);
  const getLandingLink = () => {
    if (sectionData?.components[2]?.landing?.components[3]?.metadata?.text) {
      return sectionData?.components[2]?.landing?.components[3]?.metadata?.text;
    } else {
      return '{{link}}';
    }
  };
  const convertToHtml = (sectionData) => {
    const html = ReactDOMServer.renderToStaticMarkup(
      <Section
        nodeData={sectionData}
        renderHTML={true}
        isProceed={extraProps.isProceed}
        pixel={extraProps.pixelURL}
        landingLink={getLandingLink()}
      />
    );

    return html;
  };

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      extraProps?.callbackHtml(convertToHtml(sectionData));
    }
  }, [extraProps?.convertedHtml]);

  // const mockData = sectionData?.sections[0];
  const emailRef = useRef(null);
  return (
    <section style={{ width: '95%', paddingBottom: '5%' }}>
      <div
        onClick={(e) => {
          e.stopPropagation(); // prevent the click from event Capturing, in email onClick events do not work
          e.preventDefault();
        }}
      >
        {/* for diy-web data */}

        <Section
          sectionRef={emailRef}
          customHtmlData={extraProps?.customHtmlData}
          nodeData={sectionData}
        />

        {/* for template mock data */}

        {/* <Section nodeData={mockData} /> */}
      </div>
    </section>
  );
}
